module.exports = __webpack_public_path__ + "static/content-7c16c13d3c6025410abb8ee814d5e783.png";